import { ReactElement } from 'react';

import ConfirmModal from '~/ui/components/common/ConfirmModal';

interface IArchiveConfirmModalProps {
  subject: string;
  isLoading: boolean;
  onConfirm: VoidFunction;
  onClose: VoidFunction;
}

const ArchiveConfirmModal = ({
  subject,
  isLoading,
  onConfirm,
  onClose,
}: IArchiveConfirmModalProps): ReactElement => (
  <ConfirmModal
    description={`Are you sure you want to archive this ${subject}?`}
    confirmText="Archive"
    isLoading={isLoading}
    onConfirm={onConfirm}
    onClose={onClose}
  />
);

export default ArchiveConfirmModal;
